const config = {
  env: "local",
  // apiUrl: "http://192.168.0.124:5300/api/",
   apiUrl: "https://api.vedikstar.com/api/",
};

export default config;
